import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type {
  CloneWebhookParams,
  WebhookGetBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  webhookUuid: string
  params: CloneWebhookParams
  onSuccess?: (response: WebhookGetBody) => void
  children?: () => ReactElement
}

const CloneWebhookRequest = ({
  webhookUuid,
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks/${webhookUuid}/clone`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CloneWebhookRequest
